/** The Slip mark (brand/kit/logo/mark/mark-light.svg): navy front panel, coral back panel. */
export default function AgentMark({ className = "h-5 w-5" }) {
    return (
        <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
            <rect x="26" y="10" width="20" height="36" rx="10" fill="#F05941" />
            <rect x="18" y="18" width="20" height="36" rx="10" fill="currentColor" />
        </svg>
    );
}
